import './App.css';
import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

// components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// pages
import Home from './pages/Home';


// pages details
import Services_details from './pages/page_details/Services_details';
import About from './pages/About';

function App() {
  const location = useLocation();

  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App bg-light">
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services/:search_title" element={<Services_details />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
